export default {
  retail: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Commercio e ristorazione',
    hero: {
      eyebrow: 'Commercio e ristorazione',
      title: 'Più sicurezza in negozi e ristorazione',
      lead: 'Ingresso, cassa, magazzino e accesso cucina: proteggiamo la tua attività da furti e vandalismo senza disturbare i clienti.',
    },
    points: {
      title: 'Punti di sorveglianza per commercio e ristorazione',
      lead: 'Ogni negozio e attività di ristorazione ha le proprie aree di rischio. Posizioniamo le telecamere dove fanno la differenza.',
      items: {
        '0': { title: 'Ingresso e vetrina', desc: 'Il primo punto di sorveglianza: le telecamere all’ingresso documentano chi entra ed esce e dissuadono fin dall’accesso.' },
        '1': { title: 'Zona cassa', desc: 'La cassa e l’area pagamento sono il punto più sensibile del commercio. Telecamere discrete proteggono senza allarmare i clienti.' },
        '2': { title: 'Area vendita', desc: 'Visione dell’intera superficie: le telecamere grandangolo rilevano movimenti sospetti tra scaffali e corsie.' },
        '3': { title: 'Magazzino e consegne', desc: 'Ricevimento merci, magazzino e accessi del personale: qui si creano falle. Le chiudiamo.' },
        '4': { title: 'Bancone e accesso cucina', desc: 'Nella ristorazione, bancone e accesso cucina sono aree critiche. Telecamere robuste resistono a umidità e calore.' },
        '5': { title: 'Dehor e terrazza', desc: 'Terrazza e tavoli esterni invitano i malintenzionati, specie la sera. Telecamere resistenti tengono d’occhio.' },
      },
    },
    protection: {
      eyebrow: 'Antifurto',
      title: 'Meno perdite di inventario, più sicurezza',
      lead: 'Taccheggio e differenze inventariali costano caro ogni anno. Telecamere ben posizionate riducono le perdite e forniscono immagini utili.',
      items: {
        '0': { title: 'Monitoraggio cassa', desc: 'Immagini nitide di cassa e area pagamento, per documentazione completa in caso di dispute.' },
        '1': { title: 'Vetrine e accessi', desc: 'Dissuasione e chiarimento in caso di vandalismo o effrazione, dalla vetrina all’ingresso posteriore.' },
        '2': { title: 'Registri eventi', desc: 'Movimento, attraversamento di linea o eventi porta attivano registrazione e notifiche push.' },
      },
    },
    gastro: {
      eyebrow: 'Ristorazione',
      title: 'Tecnologia robusta per bancone, cucina e terrazza',
      lead: 'Vapore, grasso e umidità richiedono molto alla tecnologia. Scegliamo telecamere affidabili nella quotidianità della ristorazione, che i clienti non notano.',
      list: {
        '0': 'Sorvegliare l’accesso cucina: solo personale autorizzato',
        '1': 'Proteggere bancone e cassa senza disturbare gli ospiti',
        '2': 'Tenere d’occhio dehor e terrazza nelle ore serali',
        '3': 'Documentare fornitori e consegne senza lacune',
        '4': 'Applicare segnaletica per ospiti e personale',
      },
      note: 'Nota: la liceità della videosorveglianza dipende dal caso. Ti consigliamo, senza sostituire la consulenza legale.',
    },
    cta: {
      title: 'La tua attività merita un contesto sicuro',
      lead: 'Ti mostriamo senza impegno dove la videosorveglianza conviene e dove non è necessaria.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Scopri SSG Care',
    },
  },
};